// Лимит ответа под комментарием Instagram робота «Сообщение по ключевым
// словам» — дублирует KeywordMessageHelper.MaxCommentReplyLength бэкенда.
export const COMMENT_REPLY_TEXT_MAX_LENGTH = 1000;
